export default "__VITE_ASSET__dacf100b__"